import React from 'react'
import { MdDelete } from 'react-icons/md';

const DeleteButton = ({ onDelete, disabled }) => (
    <button className="delete-button" onClick={onDelete} disabled={disabled}>
        <MdDelete size='18px' />&nbsp;Delete
    </button>
)

export default DeleteButton